const getShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage = () => {
  const shouldShowEnterPasswordToLinkFacebookToast = JSON.parse(localStorage.getItem('anova_should_show_enter_password_to_link_facebook_toast'))

  return shouldShowEnterPasswordToLinkFacebookToast
}

export default getShouldShowEnterPasswordToLinkFacebookToastFromLocalStorage
